var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('../lib/option'),
  optionFromString = _require.optionFromString;
const mmDeliveryFormPickBehavior = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const _transientContext$sel = transientContext.selection,
    selection = _transientContext$sel === void 0 ? {} : _transientContext$sel,
    _transientContext$con = transientContext.content,
    _transientContext$con2 = _transientContext$con === void 0 ? {} : _transientContext$con,
    _transientContext$con3 = _transientContext$con2.deliveryForm,
    deliveryForm = _transientContext$con3 === void 0 ? {} : _transientContext$con3;
  const _Object$keys = Object.keys(deliveryForm),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    deliveryFormID = _Object$keys2[0];
  if (deliveryFormID === undefined) {
    return;
  }
  const collection = {};
  let numAssets = 0;
  const assetPatches = [{
    stage: null
  }, {
    stage: optionFromString('Pending Shipment')
  }];
  const formTypes = Object.keys(selection);
  for (let i = 0; i < formTypes.length; i += 1) {
    const formType = formTypes[i];
    const formIDs = selection[formType];
    for (let j = 0; j < formIDs.length; j += 1) {
      const formID = formIDs[j];
      collection[formID] = {
        form: {
          [formID]: {
            _formRef: formID
          }
        },
        _created: numAssets + 1
      };
      numAssets += 1;

      // eslint-disable-next-line no-await-in-loop
      await sourceEvaluator({
        type: 'patchContentBehavior',
        unsafePatch: true,
        id: formID,
        patches: assetPatches
      });
    }
  }
  await sourceEvaluator({
    type: 'patchContentBehavior',
    id: deliveryFormID,
    patches: [{
      assetsPicked: collection
    }]
  });
  const addedString = numAssets === 1 ? '1 asset' : "".concat(numAssets, " assets");
  await sourceEvaluator({
    type: 'alertBehavior',
    message: "".concat(addedString, " added."),
    options: [{
      title: 'OK'
    }]
  });
};
module.exports = {
  evaluate: mmDeliveryFormPickBehavior
};